import React from 'react';
import { render } from 'react-dom';

export const ConfirmAlertWithContent = (options) => {
  const rootElement = document.getElementById('my-confirm-modal');

  const close = () => {
    render(<div id="my-confirm-modal" />, rootElement);
  };
  const opt = {
    onClose: false,
    title: 'Confirmation',
    content: 'Are you sure?',
    s: '--',
    onYes: (cb) => cb(),
    onNo: (cb) => cb(),
    yesLabel: 'Save',
    noLabel: 'No',
    className: 'container mx-auto modal-md',
    ...options,
  };
  const handleYes = () => {
    opt.onYes(close);
  };
  const handleNo = () => {
    opt.onNo(close);
  };

  render(
    <div>
      <form onSubmit={handleYes}>
        <div style={{ position: 'absolute' }}>
          <div
            className="modal show"
            style={{
              display: 'block',
              zIndex: 1051,
              backgroundColor: 'rgba(0, 0, 0, .6)',
              pointerEvents: 'none',
            }}
          >
            <div className="modal-dialog" style={{ pointerEvents: 'initial' }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">{opt.title}</h4>
                </div>
                <div className="modal-body p-4 flex justify-center text-center">
                  {typeof opt.content === 'function'
                    ? opt.content()
                    : opt.content}
                </div>
                <div className="modal-footer flex justify-center bg-primary-50 rounded-b-lg border-t border-solid border-primary-100 p-3 space-x-4">
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary "
                    onClick={handleYes}
                  >
                    {opt.yesLabel}
                  </button>{' '}
                  {options.noLabel ? (
                    <button
                      type="button"
                      className="btn --light py-2 px-6 text-base font-bold"
                      onClick={handleNo}
                    >
                      {opt.noLabel}
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          {
            // eslint-disable-next-line
            <div
              className="modal-backdrop fade show"
              style={{ zIndex: 1050, pointerEvents: 'initial' }}
              onClick={handleNo}
            />
          }
        </div>
      </form>
    </div>,
    rootElement
  );
};

export default ConfirmAlertWithContent;
